import { render, staticRenderFns } from "./PuiDocumentPdfViewer.vue?vue&type=template&id=1b084e9c"
import script from "./PuiDocumentPdfViewer.vue?vue&type=script&lang=js"
export * from "./PuiDocumentPdfViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports